import {} from "../../request/api";
const state = {
    planreleMap: {
        DynamicAreaByPlanid: new L.layerGroup(), //图标图层
        AirportControlZoneByPlanid: new L.layerGroup(), //图标图层
    },
    taskMap: {
        TaskAreaByPlanid: new L.layerGroup(),
    }

};
const mutations = {
    changeMap(state) {
        state.planreleMap.DynamicAreaByPlanid.addTo(map);
        state.taskMap.TaskAreaByPlanid.addTo(map);
        state.planreleMap.AirportControlZoneByPlanid.addTo(map);
    },

};
const actions = {
    initMapDataAction(context) {
        context.commit('changeMap');
    },
};

const getters = {
    planreleMap(state) {
        return state.planreleMap;
    },
    taskMap(state) {
        return state.taskMap;
    },
};

export default {
    state,
    mutations,
    actions,
    getters,
    // 命名空间
    namespaced: true, //使用命名空间
}